export default {
      id: "optional-features-def-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#optional-features-def",
      toString: function () {
        return this.url;
      }
    }